// extracted by mini-css-extract-plugin
module.exports =  {"divider":"DropdownDivider-module__divider___I2nES"};